






















































































import _ from 'lodash'
import moment from 'moment'
import { Getter, Action } from 'vuex-class'
import { Component } from 'vue-property-decorator'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class ProfileComponent extends VueExtendedBaseComponent {

  private editProfileDialog = false
  private currentData = {}
  private tab = 0
  private caregiverLevel = {
    10: 'ขั้นพื้นฐาน',
    20: 'ขั้นสูง',
  }

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('userprofile/getLine')
  private line!: UserProfile

  get isCaregiver() {
    return this.profile && this.profile.role ? this.profile.role.name === 'นักบริบาล' : false
  }

  get levelIcon() {
    if (this.level) {
      switch (this.level.mode) {
        case 'all': return 'account-child-circle'
        case 'center': return 'hospital-building'
        default: return 'account'
      }
    }
    return 'account'
  }

  @Action('userprofile/getUserProfile')
  private getUserProfile!: (options: {}) => void

  private doConvertUnixDate(date: number) {
    return moment.unix(date).locale('th').add(543, 'year').format('DD MMMM YYYY')
  }

  get selfDetail() {
    return this.profile ?
      [
        {
          label: 'วัน/เดือน/ปีเกิด',
          value: this.localeDate(this.profile.birthdate),
        },
        {
          label: 'เบอร์โทรศัพท์',
          value: this.profile.phone,
        },
        {
          label: 'ที่อยู่',
          value: this.mapAddress(this.profile.address),
        },
      ] : []
  }

  get profileCaregiver() {
    return this.profile && this.profile.metadata && this.profile.metadata.profile
  }

  get caregiverDetail() {
    return this.profile && this.profile.metadata ?
      [
        {
          label: 'ศูนย์บริการ',
          value: this.profile.center && this.profile.center.name || '-',
        },
        {
          label: 'หลักสูตร',
          value: this.caregiverLevel[this.profile.metadata.caregiverLevel] || '-',
        },
        {
          label: 'วุฒิการศึกษา',
          value: this.profile.metadata.graduate || '-',
        },
        {
          label: 'ภาษา',
          value: this.profile.metadata.language && this.profile.metadata.language.join(', ') || '-',
        },
        {
          label: 'ประสบการณ์',
          value: this.profile.metadata.experience || '-',
        },
        {
          label: 'ความสามารถพิเศษ',
          value: this.profile.metadata.charisma || '-',
        },
        {
          label: 'สถานภาพ',
          value: this.profile.metadata.status || '-',
        },
        {
          label: 'สัญชาติ',
          value: this.profile.metadata.nationality || '-',
        },
        {
          label: 'เชื้อชาติ',
          value: this.profile.metadata.ethnicity || '-',
        },
        {
          label: 'ศาสนา',
          value: this.profile.metadata.religion || '-',
        },
      ] : []
  }

  get profileDetail() {
    return this.profile
      ? [
        {
          title: 'ข้อมูลส่วนตัว',
          icon: 'account',
          detial: [
            {
              label: 'วัน/เดือน/ปีเกิด',
              value: this.localeDate(this.profile.birthdate),
            },
            // {
            //   label: 'เลขบัตรประชาชน',
            //   value: this.profile.idCard,
            // },
          ],
        },
        {
          title: 'ข้อมูลการติดต่อ',
          icon: 'phone-in-talk',
          detial: [
            {
              label: 'เบอร์โทรศัพท์',
              value: this.profile.phone,
            },
            {
              label: 'ที่อยู่',
              value: this.mapAddress(this.profile.address),
            },
          ],
        },
      ]
      : undefined
  }

  private async doGetLists() {
    await this.getUserProfile({})
  }

  private async openDialog() {
    this.currentData = {
      ..._.cloneDeep(this.profile),
      phone: this.profile.phone
        ? (_.startsWith(this.profile.phone, '0') ? this.profile.phone : `0${this.profile.phone}`)
        : undefined,
    }
    this.editProfileDialog = true
  }
}
